import './MainVisual.svelte.css.proxy.js';
/* src/components/index/MainVisual.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	noop,
	query_selector_all,
	run_all,
	safe_not_equal,
	set_style,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Wrap from "../slot/Wrap.svelte.js";
import { slides } from "../../_config/mainvisual.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	child_ctx[5] = i;
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	child_ctx[5] = i;
	return child_ctx;
}

// (67:6) {#each slides as s, index}
function create_each_block_1(ctx) {
	let li;
	let img;
	let img_src_value;
	let img_srcset_value;
	let img_alt_value;
	let li_class_value;

	return {
		c() {
			li = element("li");
			img = element("img");
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);

			img = claim_element(li_nodes, "IMG", {
				sizes: true,
				src: true,
				srcset: true,
				alt: true,
				loading: true,
				class: true
			});

			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(img, "sizes", "100vw");
			if (img.src !== (img_src_value = /*s*/ ctx[3].src)) attr(img, "src", img_src_value);
			attr(img, "srcset", img_srcset_value = "" + (/*s*/ ctx[3].sp + " 768w, " + /*s*/ ctx[3].src));
			attr(img, "alt", img_alt_value = /*s*/ ctx[3].name);
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-m7p5ze");
			attr(li, "class", li_class_value = "slide--" + /*index*/ ctx[5] + " svelte-m7p5ze");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, img);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (78:6) {#each slides as s, index}
function create_each_block(ctx) {
	let li;
	let img;
	let img_src_value;
	let img_srcset_value;
	let img_alt_value;
	let t;
	let li_class_value;

	return {
		c() {
			li = element("li");
			img = element("img");
			t = space();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);

			img = claim_element(li_nodes, "IMG", {
				sizes: true,
				src: true,
				srcset: true,
				alt: true,
				loading: true,
				class: true
			});

			t = claim_space(li_nodes);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(img, "sizes", "100vw");
			if (img.src !== (img_src_value = /*s*/ ctx[3].src)) attr(img, "src", img_src_value);
			attr(img, "srcset", img_srcset_value = "" + (/*s*/ ctx[3].sp + " 768w, " + /*s*/ ctx[3].src));
			attr(img, "alt", img_alt_value = /*s*/ ctx[3].name);
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-m7p5ze");
			attr(li, "class", li_class_value = "slide--" + /*index*/ ctx[5] + " svelte-m7p5ze");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, img);
			append(li, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (59:2) <Wrap fullOnMobile>
function create_default_slot(ctx) {
	let button0;
	let img0;
	let img0_src_value;
	let t0;
	let button1;
	let img1;
	let img1_src_value;
	let t1;
	let ul;
	let t2;
	let mounted;
	let dispose;
	let each_value_1 = slides;
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each_value = slides;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			button0 = element("button");
			img0 = element("img");
			t0 = space();
			button1 = element("button");
			img1 = element("img");
			t1 = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t2 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			button0 = claim_element(nodes, "BUTTON", { id: true, class: true });
			var button0_nodes = children(button0);
			img0 = claim_element(button0_nodes, "IMG", { src: true, alt: true, class: true });
			button0_nodes.forEach(detach);
			t0 = claim_space(nodes);
			button1 = claim_element(nodes, "BUTTON", { id: true, class: true });
			var button1_nodes = children(button1);
			img1 = claim_element(button1_nodes, "IMG", { src: true, alt: true, class: true });
			button1_nodes.forEach(detach);
			t1 = claim_space(nodes);
			ul = claim_element(nodes, "UL", { id: true, style: true, class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(ul_nodes);
			}

			t2 = claim_space(ul_nodes);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img0.src !== (img0_src_value = "/images/arrow-prev.png")) attr(img0, "src", img0_src_value);
			attr(img0, "alt", "＜");
			attr(img0, "class", "svelte-m7p5ze");
			attr(button0, "id", "prev");
			attr(button0, "class", "prev svelte-m7p5ze");
			if (img1.src !== (img1_src_value = "/images/arrow-next.png")) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "＞");
			attr(img1, "class", "svelte-m7p5ze");
			attr(button1, "id", "next");
			attr(button1, "class", "next svelte-m7p5ze");
			attr(ul, "id", "slides");
			set_style(ul, "width", slides.length * 2 * 100 + "%");
			set_style(ul, "left", "-" + 100 * /*center*/ ctx[0] + "%");
			attr(ul, "class", "svelte-m7p5ze");
		},
		m(target, anchor) {
			insert(target, button0, anchor);
			append(button0, img0);
			insert(target, t0, anchor);
			insert(target, button1, anchor);
			append(button1, img1);
			insert(target, t1, anchor);
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(ul, null);
			}

			append(ul, t2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			if (!mounted) {
				dispose = [
					listen(button0, "click", /*decrement*/ ctx[2]),
					listen(button1, "click", /*increment*/ ctx[1])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*slides*/ 0) {
				each_value_1 = slides;
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(ul, t2);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;
			}

			if (dirty & /*slides*/ 0) {
				each_value = slides;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*center*/ 1) {
				set_style(ul, "left", "-" + 100 * /*center*/ ctx[0] + "%");
			}
		},
		d(detaching) {
			if (detaching) detach(button0);
			if (detaching) detach(t0);
			if (detaching) detach(button1);
			if (detaching) detach(t1);
			if (detaching) detach(ul);
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let script;
	let t0;
	let t1;
	let div;
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			script = element("script");
			t0 = text("document.addEventListener('DOMContentLoaded', function() {\n      var LENGTH = 3;\n      var center = LENGTH;\n      var slides = document.getElementById('slides');\n      var prev = document.getElementById('prev');\n      var next = document.getElementById('next');\n\n      setPosition(center);\n\n      prev.addEventListener('click', function() {\n        console.log('load');\n        center += 1;\n\n        if(center === LENGTH * 2 - 1) {\n          center = LENGTH - 1;\n        }\n\n        setPosition(center);\n      });\n\n      next.addEventListener('click', function() {\n        center -= 1;\n\n        if(center === 1) {\n          center = LENGTH * 2 - 2;\n        }\n\n        setPosition(center);\n      });\n\n      function setPosition(position) {\n        var margin = 100 * position;\n        slides.style.left = '-' + margin + '%';\n      }\n    });");
			t1 = space();
			div = element("div");
			create_component(wrap.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-15kamwl\"]", document.head);
			script = claim_element(head_nodes, "SCRIPT", { nomodule: true });
			var script_nodes = children(script);
			t0 = claim_text(script_nodes, "document.addEventListener('DOMContentLoaded', function() {\n      var LENGTH = 3;\n      var center = LENGTH;\n      var slides = document.getElementById('slides');\n      var prev = document.getElementById('prev');\n      var next = document.getElementById('next');\n\n      setPosition(center);\n\n      prev.addEventListener('click', function() {\n        console.log('load');\n        center += 1;\n\n        if(center === LENGTH * 2 - 1) {\n          center = LENGTH - 1;\n        }\n\n        setPosition(center);\n      });\n\n      next.addEventListener('click', function() {\n        center -= 1;\n\n        if(center === 1) {\n          center = LENGTH * 2 - 2;\n        }\n\n        setPosition(center);\n      });\n\n      function setPosition(position) {\n        var margin = 100 * position;\n        slides.style.left = '-' + margin + '%';\n      }\n    });");
			script_nodes.forEach(detach);
			head_nodes.forEach(detach);
			t1 = claim_space(nodes);
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(wrap.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			script.noModule = true;
			attr(div, "class", "mainvisual svelte-m7p5ze");
		},
		m(target, anchor) {
			append(document.head, script);
			append(script, t0);
			insert(target, t1, anchor);
			insert(target, div, anchor);
			mount_component(wrap, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const wrap_changes = {};

			if (dirty & /*$$scope, center*/ 129) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(script);
			if (detaching) detach(t1);
			if (detaching) detach(div);
			destroy_component(wrap);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let center = slides.length;

	function increment() {
		$$invalidate(0, center += 1);

		if (center === slides.length * 2 - 1) {
			$$invalidate(0, center = slides.length - 1);
		}
	}

	function decrement() {
		$$invalidate(0, center -= 1);

		if (center === 1) {
			$$invalidate(0, center = slides.length * 2 - 2);
		}
	}

	return [center, increment, decrement];
}

class MainVisual extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default MainVisual;
//# sourceMappingURL=MainVisual.svelte.js.map
